const {
  SOURCE_MM,
} = require('./../../../../sourceList')
const {
  CR_1_4,
} = require('./../../../../crList')
const {
  SIZE_MEDIUM,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_UNDEAD,
} = require('./../../../../creatureTypeIdList')
const {
  ALIGNMENT_NE,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
} = require('./../../../../speedList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  LANG_ALL_KNOWN_AT_LIFE,
} = require('./../../../../languageIdList')
const {
  DAMAGE_BLUDGEONING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  GENDER_MALE,
} = require('./../../../../genderList')
const {
  zombieDesciptionList,
} = require('./../../../../textCommonParts')
const {
  ABILITY_UNDEAD_FORTITUDE,
} = require('./../../../../creatureAbilityList')
const {
  CREATURE_ZOMBIE,
} = require('./../../../../creatureIdList')

module.exports = {
  name: 'Зомби',
  nameEn: 'Zombie',
  id: CREATURE_ZOMBIE,
  description: zombieDesciptionList,
  note: {
    text: `После смерти Бика мы сотворили над его телом заклинание „Восставший труп“. Это было забавно, пока зомби не начал вонять, поэтому мы облили его маслом и отправили в костёр. Бик, наверное, оценил бы шутку`,
    author: `Фонкин Ноддипик, друг`,
  },
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_UNDEAD,
  ],
  alignmentId: ALIGNMENT_NE,
  source: {
    id: SOURCE_MM,
    page: 164,
  },
  armor: 8,
  hp: {
    diceCount: 3,
  },
  speed: {
    [SPEED_WALK]: 20,
  },
  params: {
    [PARAM_STR]: 13,
    [PARAM_DEX]: 6,
    [PARAM_CON]: 16,
    [PARAM_INT]: 3,
    [PARAM_WIT]: 6,
    [PARAM_CHA]: 5,
  },
  saveThrowList: [
    PARAM_WIT,
  ],
  immunityList: [
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    [CONDITION_POISONED],
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    {
      id: LANG_ALL_KNOWN_AT_LIFE,
      doNotSpeak: true,
    },
  ],
  cr: CR_1_4,
  featureList: [
    {
      id: ABILITY_UNDEAD_FORTITUDE,
      damageType: `излучением`,
    },
  ],
  actionList: [
    {
      name: 'Удар',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 3,
        range: 5,
        hit: {
          type: DAMAGE_BLUDGEONING,
          diceCount: 1,
          diceType: 6,
          diceBonus: 1,
        },
      },
    },
  ],
  genderId: GENDER_MALE,
}
